import type { ComponentType } from "react";
import { DataMapperWizardFooter, DataMapperWizardHeader } from "./DataMapperWizardFrame";

/** A step screen inside the wizard frame. Used by dataMapperRoutesList.ts on every Data Mapper body. */
export function withWizardFrame<P extends object>(Body: ComponentType<P>): ComponentType<P> {
  const Framed = (props: P) => (
    <>
      <DataMapperWizardHeader />
      <Body {...props} />
      <DataMapperWizardFooter />
    </>
  );
  Framed.displayName = `WithWizardFrame(${Body.displayName ?? Body.name ?? "Body"})`;
  return Framed;
}
